/**
 * Modal dialog implementation.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded'
import { ReactElement } from 'react'
import './jobui/styles/globals.css'
import './ModalDialog.css'

export interface ModalDialogProps {
  id?: string
  title: string
  description?: string
  contents: ReactElement
  isVisible: boolean
  changeVisible: (isVisible: boolean) => void
  className?: string
}

const ModalDialog = (props: ModalDialogProps) => {
  return (
    <Dialog
      open={props.isVisible}
      onClose={() => props.changeVisible(false)}
      className={`modal-dialog-root ${props.className}`}
      disableScrollLock
      maxWidth="lg"
      scroll="paper"
      slotProps={{
        paper: {
          id: props.id,
        },
      }}
    >
      <button
        onClick={() => props.changeVisible(false)}
        className="modal-dialog-close"
        aria-label="Close"
      >
        <DisabledByDefaultRoundedIcon />
      </button>

      <DialogTitle className="modal-dialog-title">{props.title}</DialogTitle>

      <DialogContent className="modal-dialog-panel">
        {props.description && (
          <div className="modal-dialog-description">{props.description}</div>
        )}
        <div className="modal-dialog-contents">{props.contents}</div>
      </DialogContent>
    </Dialog>
  )
}

export default ModalDialog
